import type { ReactElement } from "react";
import { CircleAlert, Loader2, RefreshCw } from "lucide-react";

import { Button } from "../ui/button";

export function RemoteThreadError(props: {
  readonly message: string;
  readonly onRetry: () => void;
}): ReactElement {
  return (
    <div className="flex flex-1 items-center justify-center px-6">
      <div className="max-w-md text-center">
        <CircleAlert className="mx-auto size-5 text-destructive" aria-hidden="true" />
        <h2 className="mt-3 text-sm font-medium">Transcript unavailable</h2>
        <p className="mt-1 text-sm text-muted-foreground">{props.message}</p>
        <Button className="mt-4" size="sm" variant="outline" onClick={props.onRetry}>
          <RefreshCw className="size-4" aria-hidden="true" />
          Retry
        </Button>
      </div>
    </div>
  );
}

export function RemoteThreadLoading(props: { readonly historyOnly: boolean }): ReactElement {
  const label = props.historyOnly ? "Synchronizing saved history" : "Loading conversation";
  return (
    <div className="relative flex min-h-0 flex-1 flex-col">
      <div
        className="mx-auto flex w-full max-w-3xl items-center gap-2 px-4 py-6 text-sm text-muted-foreground"
        data-testid={props.historyOnly ? "remote-thread-history-synchronizing" : undefined}
        role="status"
      >
        <Loader2 className="size-4 animate-spin motion-reduce:animate-none" aria-hidden="true" />
        {label}
      </div>
    </div>
  );
}
